// extracted by css-extract-rspack-plugin
var _1 = "n";
var _2 = "gy";
var _3 = "gz";
var _4 = "h";
var _5 = "gv";
var _6 = "gw";
var _7 = "fu";
var _8 = "gx";
var _9 = "g";
var _a = "b";
var _b = "f";
export { _1 as "buttonComponent", _2 as "commentArea", _3 as "commentInput", _4 as "content", _5 as "discountReviewModal", _6 as "discountReviewOpinionComponent", _7 as "footer", _8 as "headerTitle", _9 as "inner", _a as "modalComponent", _b as "wrapper" }
